<template>
  <div class="delete-note-handwriting d-none d-md-flex">
    <ib-handwriting :text="$t('handwriting.clickHereToDeleteAllTemplateItems')">
      <template #arrow>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 116.3 28.1" v-bind:svg-inline="''" v-bind:width="'80'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" transform="rotate(-49.803 58.168 23.346)" d="M19.5-20.1h77.4v86.9H19.5z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><path fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" d="M94.4 16.4c-5.3-1.3-10.7-2.1-16.2-2.4-2.1-.2-4.2-.3-6.4-.6-8.9-1-17.9-1.2-26.9-.6-12.7.8-25.2 3.3-37.2 7.4-1.6.5-3.1 1.1-4.7 1.7-.9.3-1.6.9-2.1 1.7-.2.4-.3.9-.2 1.3.1.4.4.8.7 1.1.1.1.3.2.4.2h.5c.1 0 .3-.1.4-.2l.3-.3c1.7-2 4-3.4 6.5-3.9 15.2-5 31.1-7.4 47.1-7 13.4.2 26.7 1.7 39.7 4.7.5.1 1.3.1 1 1.1-.5.1-1.1.2-1.7.2l-12.3.8c-.8 0-1.5.2-2.2.4-.1.1-.2.1-.3.3-.1.1-.2.2-.2.4 0 .1-.1.2 0 .3 0 .1 0 .2.1.3.1.1.1.2.2.2.1.1.2.1.3.1.7.2 1.5.4 2.2.4 4.5-.2 9.1-.2 13.6-.8 5.2-1 10.6-1 15.8-.2 1.6.4 2.8-.2 2.7-.9-.1-.5-.3-.9-.5-1.2-.3-.4-.7-.6-1.1-.8-.8-.4-1.7-.8-2.5-1-4.3-1.5-8.5-3.4-12.5-5.5-3.1-1.4-5.6-3.7-7.3-6.6l-3-5.1c-.5-.8-1.5-1.3-1.9-.9-.2.2-.3.5-.4.8-.1.3-.1.6 0 .9.2 1.1.6 2 1.3 2.9 1 1.1 1.9 2.4 2.7 3.7 1.3 2.1 3.1 3.8 5.2 5 1.5.9 2.9 1.7 4.3 2.5-1.6.5-3.6.4-5.4-.4z"/></g></svg>
      </template>
    </ib-handwriting>
  </div>
</template>

<script>
import IbHandwriting from '@/components/_v2/IbHandwriting'

export default {
  name: 'DeleteTemplateNoteHandwriting',

  components: {
    IbHandwriting
  }
}
</script>

<style scoped lang="scss">
.delete-note-handwriting {
  ::v-deep {
    .ib-handwriting-text {
      margin-top: 15px !important;
      font-size: 18px;

      @include media-breakpoint-up($lg) {
        font-size: 22px;
      }
    }
  }
}
</style>
